var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx } from "react/jsx-runtime";
import MSALAuthService from "@ane/core/lib/services/MSALAuthService/MSALAuthService";
import { AuthContextType } from "@ane/core/lib/services/MSALAuthService/IAuthContext";
import { ProgressIndicator } from "@ane/ui-components/lib/components/ProgressIndicator";
import * as React from "react";
const AuthContextProvider = ({ history, children }) => {
  const authContext = React.useMemo(() => {
    return MSALAuthService;
  }, [history]);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  React.useEffect(() => {
    const checkLogin = () => __async(void 0, null, function* () {
      const _isLoggedIn = yield authContext.isUserLoggedIn();
      setIsLoggedIn(_isLoggedIn);
    });
    checkLogin();
  }, [authContext]);
  if (!isLoggedIn) {
    return /* @__PURE__ */ jsx(ProgressIndicator, { ariaLabel: "", label: "Logging in", barHeight: 10 });
  }
  return /* @__PURE__ */ jsx(AuthContextType.Provider, { value: authContext, children });
};
export {
  AuthContextProvider
};
//# sourceMappingURL=AuthContextProvider.js.map
